import { dayjs } from '@abyss/web/tools/dayjs';

class DateService {
  public static IsValidDateTime = (date: string): string => {
    return (
      typeof date === 'string' &&
      (date.includes('-') || date.includes('/')) &&
      dayjs(
        date,
        'YYYY-MM-DD',
        'MM/DD/YYYY',
        'DD/MM/YYYY',
        'DD-MM-YYYY',
        'YYYY/MM/DD',
        'MMM D, YYYY',
        'MMMM D, YYYY',
        'D MMM YYYY',
        'D MMMM YYYY',
        'YYYY.MM.DD',
        'DD.MM.YYYY',
        true
      ).isValid()
    );
  };

  public static ToDateTime = (date: string): string | null => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format("MM/DD/YYYY hh:mm A") : null;
  };
  public static ToDate = (date: string): string | null => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format('MM/DD/YYYY') : null;
  };

  public static ToCustomFormat = (
    date: string,
    format: string
  ): string | null => {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format(format) : null;
  };
}

export { DateService };
